// 정적 외부/서비스 URL SSOT. 환경 무관 고정값만 둔다 (환경별로 갈리면 `@/env` 로 승격).
// 외부 링크 열기 분기(web window.open / native app.openExternal)는 Navigator 가 담당.

import { getAppType } from '@/shared/bridge';

export const EXTERNAL_LINKS = {
  /** 고객센터 채널톡 (브랜드 단일 워크스페이스). */
  CHANNELTALK: 'https://p6lzz.channel.io/home',
  /**
   * 헤빛온 앱 다운로드 — Play 스토어(안드로이드). **web 화면의 앱 유도 링크**가 쓴다.
   * 실행 플랫폼에 맞는 스토어로 보내야 하는 곳(강제 업데이트 등)은 `appStoreUrl()` 를 쓸 것.
   */
  APP_DOWNLOAD: 'https://play.google.com/store/apps/details?id=com.herit.heviton&hl=ko',
  /** 헤빛온 App Store(iOS) — id 기반 canonical 형태. 이름 slug 는 앱 표시명이 바뀌면 깨지므로 쓰지 않는다. */
  APP_DOWNLOAD_IOS: 'https://apps.apple.com/kr/app/id6757730865',
  /** 헤빛온 웹(REMS) 홈 — 레거시 운영 웹 로그인. 환경별로 갈리면 `@/env` 로 승격(TODO). */
  REMS_HOME: 'https://rems.heviton.com/login',
} as const;

/**
 * **실행 중인 플랫폼**의 스토어 URL — 강제 업데이트처럼 "지금 이 앱을 갱신"시켜야 할 때 쓴다.
 * web 에서 부를 일은 없지만(업데이트=새로고침) 호출되면 Play 스토어로 접는다 — 안드로이드 유입이 기본이라.
 */
export function appStoreUrl(): string {
  return getAppType() === 'ios' ? EXTERNAL_LINKS.APP_DOWNLOAD_IOS : EXTERNAL_LINKS.APP_DOWNLOAD;
}
